import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  xblockIframeTitle: {
    id: 'course-authoring.course-unit.xblock.iframe.title',
    defaultMessage: 'Course unit iframe',
    description: 'Title for the xblock iframe',
  },
  legacyEditModalIframeTitle: {
    id: 'course-authoring.course-unit.legacy.modal.xblock-edit.iframe.title',
    defaultMessage: 'Legacy xBlock edit modal',
    description: 'Title for the legacy xblock edit modal iframe',
  },
  xblockIframeLabel: {
    id: 'course-authoring.course-unit.xblock.iframe.label',
    defaultMessage: '{xblockCount} xBlocks inside the frame',
  },
  videoPickerModalTitle: {
    id: 'course-authoring.course-unit.xblock.video-editor.title',
    defaultMessage: 'Select video',
  },
});

export default messages;
